import { MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit, OnDestroy } from '@angular/core';

export interface AutoLogoutDialogResult {
  logout: boolean;
  auto: boolean;
}

@Component({
  standalone: false,
  selector: 'app-auto-logout-dialog',
  templateUrl: './auto-logout-dialog.component.html',
  styleUrls: ['./auto-logout-dialog.component.scss']
})
export class AutoLogoutDialogComponent implements OnInit, OnDestroy {
  private autoLogoutTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(private dialogRef: MatDialogRef<AutoLogoutDialogComponent, AutoLogoutDialogResult>) { }

  ngOnInit(): void {
    this.autoLogoutTimer = setTimeout(() => {
      this.confirmModalLogout(true);
    }, 60 * 1000);
  }

  ngOnDestroy() {
    this.clearTimer();
  }

  confirmModalLogout(isAuto = false) {
    this.clearTimer();
    this.dialogRef.close({ logout: true, auto: isAuto });
  }

  close() {
    this.clearTimer();
    this.dialogRef.close({ logout: false, auto: false });
  }

  private clearTimer(): void {
    if (this.autoLogoutTimer) {
      clearTimeout(this.autoLogoutTimer);
      this.autoLogoutTimer = null;
    }
  }
}
